
const partners = [
  {
    name: 'COLAS',
    description: 'Leader mondial de la construction routière',
    icon: 'ri-road-map-line'
  },
  {
    name: 'LAFARGE',
    description: 'Matériaux de construction de qualité',
    icon: 'ri-building-2-line'
  },
  {
    name: 'CATERPILLAR',
    description: 'Équipements de construction',
    icon: 'ri-truck-line'
  },
  {
    name: 'SCHNEIDER',
    description: 'Solutions électriques et énergétiques',
    icon: 'ri-flashlight-line'
  },
  {
    name: 'HILTI',
    description: 'Outils et technologies de construction',
    icon: 'ri-tools-line'
  },
  {
    name: 'SAINT-GOBAIN',
    description: 'Solutions pour l\'habitat durable',
    icon: 'ri-home-gear-line'
  }
];

const stats = [
  { number: '500+', label: 'Projets Réalisés' },
  { number: '50+', label: 'Collaborateurs' },
  { number: '98%', label: 'Clients Satisfaits' },
  { number: '15', label: 'Ans d\'Expérience' }
];

const CertificationsSection = () => {
  return (
    <section className="py-20 px-4 bg-gradient-to-br from-blue-600 to-blue-800">
      <div className="max-w-7xl mx-auto">
        {/* Partenaires */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Nos Partenaires
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Des collaborations stratégiques avec les leaders mondiaux de la construction
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {partners.map((partner, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-xl p-8 hover:bg-white/20 transition-all duration-300 border border-white/20"
            >
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className={`${partner.icon} text-3xl text-blue-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3 text-center">{partner.name}</h3>
              <p className="text-blue-100 text-center leading-relaxed">{partner.description}</p>
            </div>
          ))}
        </div>

        {/* Stats - Hidden */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" style={{ display: 'none' }}>
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-5xl md:text-6xl font-bold text-white mb-2">
                {stat.number}
              </div>
              <div className="text-blue-100 text-lg">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;
